<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="600px" persistent>
    <v-card>
      <v-card-title class="headline">{{ item.id ? 'Editar Item' : 'Novo Item' }}</v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="formValid">
          <v-text-field
            v-model="itemLocal.name"
            :rules="[rules.required, rules.nameLength]"
            label="Nome do Item"
            outlined
            dense
            required
          />

          <v-select
            v-model="itemLocal.category_id"
            :items="categories"
            item-text="name"
            item-value="id"
            label="Categoria"
            :rules="[rules.required]"
            outlined
            dense
            required
          />

          <v-text-field
            v-model="itemLocal.sku"
            :rules="[rules.skuLength]"
            label="SKU"
            outlined
            dense
          />

          <v-text-field
            v-model.number="itemLocal.price"
            :rules="[rules.required, rules.numeric]"
            label="Preço de Compra"
            prefix="R$"
            outlined
            dense
            required
            type="number"
          />

          <v-text-field
            v-model.number="itemLocal.percent"
            :rules="[rules.required, rules.percent]"
            label="Margem de Lucro (%)"
            suffix="%"
            outlined
            dense
            required
            type="number"
          />

          <v-text-field
            v-model="itemLocal.price_sell"
            label="Preço de Venda"
            prefix="R$"
            outlined
            dense
            readonly
          />

          <v-checkbox v-model="itemLocal.is_active" label="Item Ativo" dense />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="fecharDialog">Cancelar</v-btn>
        <v-btn color="#FF562B" @click="salvarItem" dark
          ><v-icon left>mdi-content-save</v-icon>Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getCategories } from '@/services/estoque/categoria-servico';

export default {
  name: 'ItemDialog',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formValid: false,
      categories: [],
      itemLocal: {
        name: '',
        category_id: null,
        sku: '',
        price: 0,
        percent: 0,
        price_sell: 0,
        is_active: true,
      },
      rules: {
        required: v => !!v || 'Campo obrigatório',
        nameLength: v => (v && v.length >= 2 && v.length <= 200) || 'Nome entre 2 e 200 caracteres',
        skuLength: v => !v || v.length <= 100 || 'SKU máx. 100 caracteres',
        numeric: v => !isNaN(parseFloat(v)) || 'Deve ser número',
        percent: v => (v >= 0 && v <= 100) || 'Percentual entre 0 e 100',
      },
    };
  },
  watch: {
    item: {
      immediate: true,
      handler(val) {
        this.itemLocal = { ...val };
        this.calculatePriceSell();
      },
    },
    'itemLocal.price': 'calculatePriceSell',
    'itemLocal.percent': 'calculatePriceSell',
  },
  mounted() {
    this.loadCategories();
  },
  methods: {
    async loadCategories() {
      try {
        this.categories = await getCategories();
      } catch (e) {
        console.error('Erro ao carregar categorias:', e);
      }
    },
    calculatePriceSell() {
      const { price, percent } = this.itemLocal;
      if (price && percent >= 0) {
        this.itemLocal.price_sell = parseFloat((price * (1 + percent / 100)).toFixed(2));
      }
    },
    salvarItem() {
      if (this.$refs.form && this.$refs.form.validate()) {
        this.$emit('submit', this.itemLocal);
        this.$emit('input', false); // fecha o dialog
      }
    },
    fecharDialog() {
      this.$emit('input', false);
    },
  },
};
</script>
